import React, { FunctionComponent } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTopOnMount: FunctionComponent<unknown> = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
